export default "__VITE_ASSET__DAhK45fE__"